import { Dispatch } from "redux";
import { ApiConfig } from "../../../../../../config/ApiConfig";
import { AppStateWithData } from "../../../../../AppStateWithData";
import { RequestThunkParameters, createRequestThunk } from "../../../../../../utils/request-actions-helpers/createRequestThunk";
import { createRequestActionTypes } from "../../../../../../utils/request-actions-helpers/createRequestActionTypes";
import { UpdateDocumentAdditionalData, DOCUMENT_CHECKLIST_TITLE_UPDATE } from "../UpdateDocumentAdditionalData";

export const updateChecklistTitleActionTypes = createRequestActionTypes('UPDATE_CHECKLIST_TITLE')

export const updateChecklistTitle = (config: ApiConfig) => (docId: string, checklistUid: string, title: string) => (dispatch: Dispatch, getState: () => AppStateWithData) => {
    const thunkParams: RequestThunkParameters<Document, never, UpdateDocumentAdditionalData> = {
        method: 'PUT',
        requestActionTypes: updateChecklistTitleActionTypes,
        url: `${config.API_URL}/checklist/updateTitle?docId=${encodeURIComponent(docId)}&checklistUid=${encodeURIComponent(checklistUid)}&title=${encodeURIComponent(title)}`,
        actionAdditionalData: {
            docId,
            updateInfo: {
                type: DOCUMENT_CHECKLIST_TITLE_UPDATE,
                checklistUid
            }
        }
    }

    dispatch<any>(createRequestThunk(thunkParams))
}